<template>
  <main-content v-if="current_user.id">
    <div class="clearfix mb-3">
      <router-link class="kt-nav__link m-2 btn btn-primary float-right" to="/advertising-banners/create">
        {{ $t('btn.create') }}
      </router-link>
    </div>
    <div v-if="current_user.permissions.length > 0" id="open-banking-requests-list">
      <kt-datatable v-bind="datatableProps" ref="datatable"></kt-datatable>
    </div>
  </main-content>
</template>

<script>
import { ApiUrl } from "@/common/api.service"
import { AuthorizationHeader } from "@/common/jwt.service"
import Columns from "@/views/advertising/datatable/columns.js"
import mainContent from "@/components/main-content.vue";
import {mapGetters} from "vuex";

export default {
  name: 'banners',
  components: {
    'main-content': mainContent,
  },

  data() {
    return {
      query: {},
    }
  },

  computed: {
    ...mapGetters('user', [
      'current_user'
    ]),
    datatableProps() {
      return {
        id: "banner_datatable",
        data: {
          type: 'remote',
          source: {
            read: {
              url: ApiUrl.path('admin/banner/get'),
              method: 'GET',
              headers: AuthorizationHeader,
              map: function (res) {
                return res.data.data
              },
              params: {
                query: this.query
              },
            },
          },
          pageSize: 10,
          serverPaging: true,
          serverFiltering: true,
          serverSorting: true,
        },
        pagination: false,
        sortable: true,
        columns: Columns,
      }
    },
  },
}
</script>
